import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, dishesByCustomer, dishesByRestaurant } =
		useContext<IDishesContext>(DishesContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={dishesByCustomer.totalCount || dishesByRestaurant.totalCount ? 800 : undefined}
		/>
	);
};
